const state = {
    products: []
}

const getters = {
    products: state => state.products
}

const mutations = {
    UPDATE_PRODUCT(state, payload) {
        state.products = payload;
    }
}

const actions = {
    setProducts({ commit }, code) {
        let products = [];
        const vuex = window.sessionStorage.getItem("vuex");
        if (vuex !== null) {
            products = JSON.parse(vuex).history.products;
        }
        products.push(code);
        commit('UPDATE_PRODUCT', products);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}